<template>
  <div fluid>
    <!-- imagen de cabecera con titulos superpuestos -->
    <v-img src="@/assets/cabecera-mascara.jpg" min-height="525_" max-height="525_">
      <v-container class="fill-height" fluid>
        <v-col>
          <v-row align="center" justify="center">
            <center style="width: auto">
              <span style="color: white; font-family: 'Montserrat',sans-serif;">
                <div class="title font-weight-thin sombra margeninferior">
                  {{ $t('inicioBienvenido') }}
                </div>
                
                <div class="display-2 sombra margeninferior">
                  {{ $t('inicioNombreParking') }}
                </div>
                
                <div
                  class="title fina sombra margeninferior"
                  style="color: #e4e4e4">
                  {{ $t('inicioReservaConNosotros') }}
                </div>
                
                <div
                  class="subtitle-1 font-weight-bold margeninferior"
                  style="color: white; background: #1ab9e4; border-radius: 3px">
                  {{ $t('inicioSomosUnicos') }}
                </div>
                
                <div class="display-2 sombra" style="margin-bottom: 32px">{{ $t('inicioPrecioSemana')}}</div>
              </span>
            </center>
          </v-row>
        </v-col>
      </v-container>
    </v-img>

    <!-- boton de reservar una plaza naranja -->
    <v-container fluid>
      <v-row justify="center" align="center" dense>
        <v-col align="center">
          <div style="margin-top: -85px; color: white">
              <router-link to="/zbe" class="mr-2 title_ fina" style="color: #e4e4e4; font-family: 'Montserrat',sans-serif;  font-size:16px;">
                 {{ $t('inicioConsulteRestricciones') }} <br>  {{ $t('inicioZBE') }}    
                <span style="white-space:nowrap;">
                    <v-img class_="ml-2" style="margin-top_: -45px;" src="@/assets/zbe.png" width="60px" height="60px" contain></v-img>
                </span>
            
              </router-link>
          </div>
        </v-col>
      
        <v-col justify="center" align="center">
          <v-card
            style="margin-top: -70px; background: #f08823; padding: 6px; user-select: none;"
            class="mx-auto"
            max-width="300"
            @click="reservarEstancia()"
          >
            <span class="headline mb-1 fina" style="color: white">
              <v-icon color="white">mdi-car</v-icon>
              <br />{{ $t('inicioReservarPlaza')}}
            </span>
          </v-card>
        </v-col>
      
        <v-col justify="center" align="center">
        </v-col>

      </v-row>
    </v-container>

    <!-- 3 tarjetas azules -->
    <v-container fluid>
      <v-row justify="center" dense>
        <v-col v-for="t in tarjetas" :key="t.titulo" cols="12" sm="8" md="3">
          <div class="mx-auto">
            <center>
              <v-icon color="#1ab9e4" size="60">{{t.icono}}</v-icon>
              <div class="title fina margeninferior" style="color: #1ab9e4">{{ $t(t.titulo) }}</div>
              <div class="fina" style="color: #66777c">{{ $t(t.descripcion) }}</div>
            </center>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!--
    *************************
    Descripcion parking
    *************************
    -->  
      <v-container align="start" justify="start">
        <v-row style="border-bottom: 1px solid orange; border-top: 1px solid orange">
          <v-col>
            <p class="text-justify">{{ $t('descripcionParkingP1') }}</p>
            <p class="text-justify">{{ $t('descripcionParkingP2') }}</p>
            <p class="text-justify">{{ $t('descripcionParkingP3') }}</p>
            <p class="text-justify">{{ $t('descripcionParkingP4') }}</p>
  <!--          <v-row 
                  class="subtitle-1 font-weight-bold"
                  style="color: white; background: #f08823; border-radius: 3px">
              <v-col justify="center" align="center">
                {{ $t('inicioSomosUnicos') }}
              </v-col>            
            </v-row> -->
          </v-col>
        </v-row>
      </v-container>



 <!--
    *************************
    Puntos de interes 
    *************************
    -->  
      <v-container align="start" justify="start">

        <v-row align="center" justify="center" style="padding-top: 10px">
          <font-awesome-icon class="iconoTituloArea fa-flip-horizontal" :icon="['fas', 'map']"/>           
          {{ $t('lugaresInteres') }}
        </v-row>


        <v-row>

          <v-col style="padding-left_: 10px; padding-right_: 10px; padding-top_: 0px;">
            <v-container>
              <v-row align="center" justify="center">
                <v-col class="col-md-4 columna" v-for="(unLugar, index) in lugaresInteres" :key="index">
                  <div class="tarjeta">
                    <v-img width="100%" style="margin-bottom: 5px;" :src="require(`@/assets/${unLugar.imagen}`)"></v-img>
                    {{ $t(unLugar.nombre) }}
      
                    <v-row cols="auto" class="mr-auto ml-auto infoAdicionaltarjeta" align="center" justify="start">
                      <font-awesome-icon class="iconoEnTarjeta" :icon="['fas', 'map-marker-alt']"/>           
                      {{ $t(unLugar.direccion) }}
                    </v-row>
      
                    <v-row cols="auto" class="mr-auto ml-auto infoAdicionaltarjeta" align="center" justify="start">
                      <font-awesome-icon class="iconoEnTarjeta" :icon="['fas', 'walking']"/>           
                      {{ cadenaTiempo(unLugar.tiempoAPie) }}
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto infoAdicionaltarjeta" align="center" justify="start">
                      <font-awesome-icon class="iconoEnTarjeta" :icon="['fas', 'hand-point-right']"/>           
                      <a :href="unLugar.enlace">{{ $t('comollegar') }}</a>
                    </v-row>
                  </div>  
                </v-col>   
              </v-row>
            </v-container>

          </v-col>

        </v-row>
      </v-container>





  </div>
</template>


<style scoped>
.sombra {
  text-shadow: 0 3px 10px rgba(0, 0, 0, 0.6);
}
.margeninferior {
  margin-bottom: 16px;
}
.fina {
  font-weight: 300 !important;
}

.iconoTituloArea{
  font-size:25px;
  color:#1A55F4; 
  margin-right: 10px;
}

.iconoEnTarjeta{
  font-size:15px;
  color:#1A55F4; 
  margin-right: 8px;
}

.infoAdicionaltarjeta {
  margin-top: 5px;
  font-size: 12px;
  color: rgb(128,128,128);
}
</style>


<script>
export default {
  name: "PaginaInicio",

  data: () => ({
    tarjetas: [
      {
        icono: "mdi-shield-check",
        titulo: "inicioTituloPlazaGarantizada",
        descripcion: "inicioPlazaGarantizada"
      },
      {
        icono: "mdi-undo",
        titulo: "inicioTituloCancelacionReembolso",
        descripcion: "inicioCancelacionReembolso"
      },
      {
        icono: "mdi-tag",
        titulo: "inicioTituloAhorra",
        descripcion: "inicioAhorra"
      }
    ],

    lugaresInteres: [
      { nombre:'puertobarcelona', 
        direccion:'direccionpuerto', 
        tiempoAPie: '0', 
        imagen: 'puerto-de-barcelona.jpg', 
        enlace:'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/41.3571442,2.1789423/@41.3572355,2.1787736,18.21z/data=!4m9!4m8!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m0!3e2'
      }, 
      { nombre: 'palaciovirreina', 
        direccion: 'direccionpalacio', 
        tiempoAPie: '46', 
        imagen: 'palacio-de-la-virreina.jpg', 
        enlace: 'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/Palacio+de+la+Virreina,+Barcelona/@41.3700389,2.159406,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a2f64f4d98f1:0x6c3672a6a9c98a04!2m2!1d2.1712553!2d41.3824077!3e2'
      }, 
      { nombre:'teatroliceo', 
        direccion:'direccionteatro', 
        tiempoAPie: '42', 
        imagen: 'gran-teatro-del-liceo.jpg', 
        enlace: 'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/Gran+Teatre+del+Liceu,+La+Rambla,+Barcelona/@41.369075,2.1604029,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a2580540cc5b:0xa05d8e0a1059639d!2m2!1d2.1732948!2d41.3801969!3e2'
      }, 
      { nombre:'larambla', 
        direccion:'direccionrambla', 
        tiempoAPie: '41', 
        imagen: 'la-rambla.jpg', 
        enlace:'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/La+Rambla,+Barcelona/@41.3689445,2.1608176,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a258081714c9:0x24bef7ac8842bdc4!2m2!1d2.1737903!2d41.3807484!3e2'
      }, 
      { nombre: 'boqueria', 
        direccion:  'direccionboqueria', 
        tiempoAPie: '46', 
        imagen: 'mercado-de-la-boqueria.jpg', 
        enlace: 'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/Mercado+de+La+Boqueria,+La+Rambla,+Barcelona/@41.3700389,2.159406,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a2f7b51e5a01:0x860ac654dc73add5!2m2!1d2.1715853!2d41.3817399!3e2'
      }, 
      { nombre:'plazareal', 
        direccion:'direccionplazareal', 
        tiempoAPie: '40', 
        imagen: 'plaza-real.jpg', 
        enlace: 'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/Plaza+Real,+Pla%C3%A7a+Reial,+Barcelona/@41.3687634,2.1612372,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a257e581f057:0x2859f63a8fc93e31!2m2!1d2.17527!2d41.3801!3e2'
      }    
    ], // fin array data.lugaresInteres

  }),
  methods: {

    cadenaTiempo: function (aTiempo){
      return aTiempo + " " + this.$t('minutos');
    }, // fin metodo cadenaTiempo

    reservarEstancia: function(){
      // inicio de una nueva reserva. 

      // Limpieza de los datos de localStorage
      window.localStorage.setItem("importeReserva", "");
      window.localStorage.setItem("importeReservaNumero", 0);
      window.localStorage.setItem("fechaEntrada", '');
      window.localStorage.setItem("fechaSalida", '');
      window.localStorage.setItem("horaSalida", "00:00");
      window.localStorage.setItem("horaEntrada", "00:00");
      window.localStorage.setItem("matricula", "");
      window.localStorage.setItem("modelo", "");
      window.localStorage.setItem("color", "");
      window.localStorage.setItem("crucero", "");

      window.localStorage.setItem("nombre", "");
      window.localStorage.setItem("mail", "");
      window.localStorage.setItem("telefono", "");
      window.localStorage.setItem("cif", "");      

      window.localStorage.setItem("direccion", "");
      window.localStorage.setItem("localidad", "");
      window.localStorage.setItem("cp", "");
      window.localStorage.setItem("nombreFac", "");      
      window.localStorage.setItem("pais", "");      
      window.localStorage.setItem("aceptacionTerminos", false);      
      
      window.localStorage.setItem("availability_request_token", '');      
      window.localStorage.setItem("availability_request_expiration_time", '');      

      // cambio de pagina
      this.$router.push({ path: '/reservar' })
  
    } // fin metodo reservarEstancia
  },  // fin methods


  mounted: function(){
    window.scrollTo(0,0);
  } // fin evento mounted

};
</script>
